import { Flex } from '@chakra-ui/react'
import React from 'react'
import Sidebar from '../../../Components/Sidebar'
import EditShipmentDetails from './EditShipmentDetails'

const EditShipment = () => {
  return (
    <Flex>
    <Sidebar />
    <EditShipmentDetails />
  </Flex>
  )
}

export default EditShipment